import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../index";

interface AppState {
  currentPage: string;
  metadata: Record<string, any>;
}

const initialState: AppState = {
  currentPage: "",
  metadata: {},
};

const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setCurrentPage: (
      state,
      action: PayloadAction<{ page: string; metadata?: Record<string, any> }>,
    ) => {
      state.currentPage = action.payload.page;
      state.metadata = action.payload.metadata || {};
    },
    updateMetadata: (state, action: PayloadAction<Record<string, any>>) => {
      state.metadata = { ...state.metadata, ...action.payload };
    },
    clearAppState: (state) => {
      state.currentPage = "";
      state.metadata = {};
    },
  },
});

// Selectors
export const selectCurrentPage = (state: RootState) => state.appState.currentPage;
export const selectPageMetadata = (state: RootState) => state.appState.metadata;

export const { setCurrentPage, updateMetadata, clearAppState } = appStateSlice.actions;
export default appStateSlice.reducer;
